export default {
    "title": "Services / {{client}}",
    "description": "Available web services for integration",
    "apiToken": "API token",
    "apiUrl": "API URL",
    "active": "Active",
    "inactive": "Inactive",
    "copied": "Copied",
    "copyError": "Error copying",
    "noServices": "No services configured for this client",
    "downloadPDF": "Download PDF",
    "stocks": {
        "name": "Stocks",
        "description": "Check stock levels automatically via API, using the following parameters:",
        "guide": "Download the user guide for this service for more information."
    }
};
